import { InputField } from "components/InputField/Input";

const useProductDataTable = (formik) => {
    const addProductOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`order_items[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const modalTableColumns = [
        {
            field: "name",
            header: "Name",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="name"
                        name="name"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "name")}
                        value={formik.values.order_items[event.rowIndex]?.name}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.name}
                    />
                </div>
            ),
        },
        {
            field: "uom",
            header: "UOM",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="uom"
                        name="uom"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "uom")}
                        value={formik.values.order_items[event.rowIndex]?.uom}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.uom}
                    />
                </div>
            ),
        },
        {
            field: "brand_name",
            header: "Brand",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="brand_name"
                        name="brand_name"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "brand_name")}
                        value={formik.values.order_items[event.rowIndex]?.brand_name}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.brand_name}
                    />
                </div>
            ),
        },
        {
            field: "product_expiry_date",
            header: "Expiry Date",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="product_expiry_date"
                        name="product_expiry_date"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "product_expiry_date")}
                        value={formik.values.order_items[event.rowIndex]?.product_expiry_date}
                        type="date"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.product_expiry_date}
                    />
                </div>
            ),
        },
        {
            field: "order_quantity",
            header: "Order Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="order_quantity"
                        name="order_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "order_quantity")}
                        value={formik.values.order_items[event.rowIndex]?.order_quantity}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.order_quantity}
                    />
                </div>
            ),
        },
        {
            field: "receive_quantity",
            header: "Receive Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="receive_quantity"
                        name="receive_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "receive_quantity")}
                        value={formik.values.order_items[event.rowIndex]?.receive_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.receive_quantity}
                    />
                </div>
            ),
        },
        {
            field: "unit_price",
            header: "Buying Price",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="unit_price"
                        name="unit_price"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "unit_price")}
                        value={formik.values.order_items[event.rowIndex]?.unit_price}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.unit_price}
                    />
                </div>
            ),
        },
        {
            field: "discount",
            header: "Discount",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="discount"
                        name="discount"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "discount")}
                        value={formik.values.order_items[event.rowIndex]?.discount}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.discount}
                    />
                </div>
            ),
        },
        {
            field: "sale_price",
            header: "Sale Price",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="sale_price"
                        name="sale_price"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "sale_price")}
                        value={formik.values.order_items[event.rowIndex]?.sale_price || 0}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.sale_price}
                    />
                </div>
            ),
        },
        {
            field: "remark",
            header: "Remark",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remark"
                        name="remark"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "remark")}
                        value={formik.values.order_items[event.rowIndex]?.remark}
                        type="text"
                        width="full"
                        autoCompleteFieldName="name"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.order_items?.[event.rowIndex]?.remark}
                    />
                </div>
            ),
        },
        {
            field: "total_unit_price",
            header: "Total unit price",
            sortableBody: (value, event) => (
                <div className="w-25" style={{"textAlign": "center"}}>
                    <span style={{"color": "#203225"}}>
                        {parseFloat((formik.values.order_items[event.rowIndex]?.receive_quantity * formik.values.order_items[event.rowIndex]?.unit_price) - formik.values.order_items[event.rowIndex]?.discount|| 0).toFixed(3)}
                    </span>
                </div>
            ),
        },
    ]

    return {
        modalTableColumns,
    }
}

export default useProductDataTable